<template>
  <section
    class="banner-down"
    :style="bannerVisible ? { backgroundImage: 'url(/images/world-gray.png)' } : {}"
  >
    <div class="banner-text" :class="{ visible: isVisible }">
      <h3>
        <strong>İntek Electronics</strong> olarak <br />
        Araştırıyoruz, Geliştiriyoruz, Üretiyoruz
      </h3>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  name: 'ScrollAnimation',

  setup() {
    const isVisible = ref(false);
    const bannerVisible = ref(false);

    const handleScroll = () => {
      const textElement = document.querySelector('.banner-text');
      if (!textElement) return;
      const rect = textElement.getBoundingClientRect();

      if (rect.top < window.innerHeight) {
        isVisible.value = true;
        bannerVisible.value = true;
      }
    };

    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
      handleScroll(); // İlk yüklemede kontrol et
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    return { isVisible, bannerVisible };
  },
};
</script>

<style scoped>
@keyframes slideIn {
  0% {
    opacity: 0;
    transform: translateY(-50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.banner-down {
  position: relative;
  background-color: #f5f5f5; /* Lazy yüklenmeden önce arka plan */
  min-height: 40vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  text-align: center;
}

.banner-text {
  font-size: clamp(20px, 4vw, 32px);
  color: #145da0;
  font-family: 'Montserrat', sans-serif;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.7s ease-in-out;
  max-width: 900px;
  margin: auto;
  line-height: 1.4em;
}

.banner-text.visible {
  opacity: 1;
  transform: translateY(0);
}

.banner-text h3 {
  font-weight: 500;
  text-transform: capitalize;
  font-size: inherit;
  margin: 0;
}

.banner-text strong {
  font-weight: 700;
}

@media (max-width: 768px) {
  .banner-down {
    min-height: 30vh;
  }
}

@media (max-width: 480px) {
  .banner-down {
    min-height: 25vh;
  }

  .banner-text {
    font-size: clamp(18px, 5vw, 24px);
  }
}
</style>